import * as Actions from "./actions";
import { ActivityTab } from "./models";
import { GlobalApplicationState } from "globalApplicationState";

export const setActiveTab = (activeTab: ActivityTab) => (dispatch, getState: () => GlobalApplicationState) => {
    dispatch(Actions.CreateSetActiveActivityTabAction({activeTab}));
}